import React, { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
let cached = null;

export function useBrandLogo() {
  const [logo, setLogo] = useState(cached);
  useEffect(() => {
    if (cached !== null) return;
    fetch(`${API}/api/branding`).then((r) => r.json()).then((d) => {
      cached = d.logo_path ? `${API}/api/branding/logo?v=${encodeURIComponent(d.updated_at || "")}` : "";
      setLogo(cached);
    }).catch(() => { cached = ""; setLogo(""); });
  }, []);
  return logo;
}

export function refreshBrandLogo() { cached = null; }

export default function Logo({ compact = false }) {
  const logo = useBrandLogo();
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img src={logo || "/ban-logo.jpg"} alt="Brothers Across Nigeria Int'l" className="h-10 w-10 rounded-full object-cover ring-2 ring-[hsl(var(--gold))]/40" data-testid="brand-logo-image" />
      {!compact && (
        <div className="leading-none">
          <div className="font-display text-base font-700 tracking-wide gold-text">IOTA GALLEON</div>
          <div className="label-eyebrow mt-1 text-[0.6rem] text-muted-foreground">Brothers Across Nigeria Int'l</div>
        </div>
      )}
    </div>
  );
}
